import { render, staticRenderFns } from "./SectionAdd.vue?vue&type=template&id=75242006&scoped=true&"
import script from "./SectionAdd.vue?vue&type=script&lang=js&"
export * from "./SectionAdd.vue?vue&type=script&lang=js&"
import style0 from "./SectionAdd.vue?vue&type=style&index=0&id=75242006&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75242006",
  null
  
)

export default component.exports